import React from 'react';
import { Link } from 'react-router-dom';

export default function AccountBtns({customer}) {
	return (
		<div className="account_section">
			{customer !== null ? (
				<React.Fragment>
					<Link className="account-btn" to="/customer/">
						Account
					</Link>
					<Link to="/customer/logout">Logout</Link>
				</React.Fragment>
			) : (
				<Link className="account-login-btn" to="/customer/login">
					Login
				</Link>
			)}
		</div>
	);
}


// WEBPACK FOOTER //
// ./src/components/header/HeaderBar/AccountBtns.js